var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('img',{attrs:{"alt":"Patent Hub logo","src":require("./../../assets/logo.svg")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }